import { userRoles } from '@/commons/constants/userRoles';

export default [
  {
    key: 'orders',
    iconComponent: 'IconFileText',
    routeName: 'Orders',
    name: 'Заказы',
    allowedRoles: [userRoles.Admin, userRoles.Dispatcher, userRoles.Specialist],
  },
  {
    key: 'specialists',
    iconComponent: 'IconUsers',
    routeName: 'Specialists',
    name: 'Сотрудники Hoff',
    allowedRoles: [userRoles.Admin],
  },
  {
    key: 'contractors',
    iconComponent: 'IconBriefcase',
    routeName: 'Contractors',
    name: 'Подрядчики',
    allowedRoles: [userRoles.Admin],
  },
  {
    key: 'my-company',
    iconComponent: 'IconBriefcase',
    routeName: 'MyCompany',
    name: 'Моя компания',
    allowedRoles: [userRoles.Dispatcher],
  },
  {
    key: 'directory',
    iconComponent: 'IconClipboard',
    routeName: 'Directory',
    name: 'Справочник',
    allowedRoles: [userRoles.Admin],
    subItems: [
      {
        key: 'services',
        routeName: 'Services',
        name: 'Услуги',
      },
      {
        key: 'registry-types',
        routeName: 'RegistryTypes',
        name: 'Тип реестра',
      },
      {
        key: 'claim-reasons',
        routeName: 'ClaimReasons',
        name: 'Рекламация',
      },
      {
        key: 'order-cancellation-reasons',
        routeName: 'OrderCancellationReasons',
        name: 'Отмена заказа',
      },
      {
        key: 'order-status-reasons',
        routeName: 'OrderStatusReasons',
        name: 'Ложный выезд',
      },
    ],
  },

  {
    key: 'settings',
    iconComponent: 'IconSettings',
    routeName: 'Settings',
    name: 'Настройки',
    allowedRoles: [userRoles.Admin],
  },
  {
    key: 'download-app',
    iconComponent: 'IconDownloadApp',
    routeName: 'DownloadApp',
    name: 'Скачать приложение',
    allowedRoles: Object.values(userRoles),
  },
  {
    key: 'password-reset',
    iconComponent: 'IconPasswordReset',
    routeName: 'PasswordReset',
    name: 'Сменить пароль',
    allowedRoles: Object.values(userRoles),
  },
];
